import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'TopicTemplate' })((theme) => ({
    root: {
        maxWidth: 1060,
        margin: '80px auto 160px auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 160,
        alignItems: 'center',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 96,
            margin: '16px auto 96px auto'
        }
    }
}));
